import { gql } from '@apollo/client'

import profilePicture from './profilePictureFragment'

const cardProfileFragment = gql`
  fragment cardProfile on PublicProfile {
    id
    name
    slug
    title
    description
    acceptingOrders
    profilePicture {
      ...profilePicture
    }
    profileVideo {
      id
      url(preset: VIDEO_DEFAULT)
    }
    defaultProfileProduct {
      id
      acceptingOrders
      price {
        valueInCent
        formattedValue
        currency
      }
      profile {
        id
        name
        slug
      }
      product {
        id
        slug
        productType
        saleMode
      }
    }
  }
  ${profilePicture}
`

export default cardProfileFragment
